

const AboutPage = () => (
    <><h1>О программе</h1></>
)


export default AboutPage
